
    <div class="contact-page modal">
        <form [formGroup]="direccionesForm" class="theme-form" (keydown.enter)="$event.preventDefault()">
            <div class="container d-flex justify-content-center">
                <div class="col-10 p-5 modal-body">
                    <div class="col-sm-12">
                        <h3>Agrega una dirección</h3>
                        <div class="row">
                            <div class="col-md-4">
                                <label for="email">Código Postal  <span class="text-danger">*</span></label>&nbsp;&nbsp;
                                <span class="text-danger"
                                    *ngIf="(direccionesForm.get('codigoPostal').touched) && direccionesForm.get('codigoPostal').errors?.required">
                                    Campo requerido
                                </span>
                                <input type="text" class="form-control"  pattern="[0-9]*" maxlength="5" formControlName="codigoPostal" id="codPostal" placeholder="Código Postal" required=""
                                (input)="getCP($event)"
                                >
                            </div>
                            <div class="col-md-4">
                                <label for="name">Estado  <span class="text-danger">*</span></label>&nbsp;&nbsp;
                                <span class="text-danger"
                                    *ngIf="(direccionesForm.get('estado').touched) && direccionesForm.get('estado').errors?.required">
                                    Campo requerido
                                </span>
                                <input type="text" class="form-control" formControlName="estado" id="home-ploat" placeholder="Estado"  required>
                            </div>
                            <div class="col-md-4">
                                <label for="name">Municipio / Alcaldía  <span class="text-danger">*</span></label>&nbsp;&nbsp;
                                <span class="text-danger"
                                    *ngIf="(direccionesForm.get('municipio').touched) && direccionesForm.get('municipio').errors?.required">
                                    Campo requerido
                                </span>
                                <input type="text" class="form-control" formControlName="municipio" id="home-ploat" placeholder="Municipio" required="">
                            </div>
                            <div class="col-md-4">
                                <label for="email">Colonia  <span class="text-danger">*</span></label>&nbsp;&nbsp;
                                <span class="text-danger"
                                    *ngIf="(direccionesForm.get('colonia').touched) && direccionesForm.get('colonia').errors?.required">
                                    Campo requerido
                                </span>
                                <input type="text" placeholder="Colonia" class="form-control" *ngIf="this.direccionesForm.controls.codigoPostal.value.length < 5" disabled>
                                <select formControlName="colonia" class="form-control" id="colonia" *ngIf="this.direccionesForm.controls.codigoPostal.value.length === 5">
                                    <option value="{{colonia}}"  *ngFor="let colonia of listColonias">{{colonia}}</option>
                                </select>
                                <!-- <input type="text" class="form-control" maxlength="30" formControlName="colonia" id="zip-code" placeholder="Colonia" required=""> -->
                            </div>
                            <div class="col-md-4">
                                <label for="name">Calle  <span class="text-danger">*</span></label>&nbsp;&nbsp;
                                <span class="text-danger"
                                    *ngIf="(direccionesForm.get('calle').touched) && direccionesForm.get('calle').errors?.required">
                                    Campo requerido
                                </span>
                                <input type="text" class="form-control" maxlength="29" formControlName="calle" id="home-ploat" placeholder="Calle" required="">
                            </div>
                            <div class="col-md-4">
                                <label for="email">N° Exterior  <span class="text-danger">*</span></label>&nbsp;&nbsp;
                                <span class="text-danger"
                                    *ngIf="(direccionesForm.get('noExterior').touched) && direccionesForm.get('noExterior').errors?.required">
                                    Campo requerido
                                </span>
                                <input type="text" (input)="soloLetrasNumerosExt($event)" class="form-control" formControlName="noExterior" id="numExt" placeholder="No. Exterior" maxlength="5" required="">
                            </div>
                            <div class="col-md-4">
                                <label for="email">N° Interior</label>
                                <input type="text" class="form-control" (input)="soloLetrasNumerosInt($event)" formControlName="noInterior" id="numInt" maxlength="80" placeholder="No. Interior">
                            </div>
                            <div class="col-md-4">
                                <label for="name">Entre Calles  <span class="text-danger">*</span></label>&nbsp;&nbsp;
                                <span class="text-danger"
                                    *ngIf="(direccionesForm.get('calleEsquina').touched) && direccionesForm.get('calleEsquina').errors?.required">
                                    Campo requerido
                                </span>
                                <input type="text" class="form-control" maxlength="35" formControlName="calleEsquina" id="address-two" placeholder="Calle esquina" required="">
                            </div>
                            <div class="col-md-4">
                                <label for="email">Referencias  <span class="text-danger">*</span> <span style="font-style: italic; color: gray; font-weight: normal;">Es necesaria para paquetería</span></label>&nbsp;&nbsp;
                                <span class="text-danger"
                                    *ngIf="(direccionesForm.get('referencia').touched) && direccionesForm.get('referencia').errors?.required">
                                   <br> Campo requerido
                                </span>
                                <input type="text" class="form-control" formControlName="referencia" maxlength="250" id="refer" placeholder="Referencia" required="">
                            </div>
                            <div class="col-md-4">
                                <label for="review">Teléfono  <span class="text-danger">*</span></label>&nbsp;&nbsp;
                                <span class="text-danger"
                                    *ngIf="(direccionesForm.get('telefono').touched) && direccionesForm.get('telefono').errors?.required">
                                    Campo requerido
                                </span>
                                <input type="text" class="form-control" formControlName="telefono" id="city" placeholder="Teléfono" maxlength="10" type="text" (input)="soloNumeros($event)" required="">
                            </div>
                            <div class="col-md-4">
                                <label for="review">Quien recibe  <span class="text-danger">*</span></label>&nbsp;&nbsp;
                                <span class="text-danger"
                                    *ngIf="(direccionesForm.get('nombreRecibe').touched) && direccionesForm.get('nombreRecibe').errors?.required">
                                    Campo requerido
                                </span>
                                <input (keyup.enter)="submit()"
                                 type="text" class="form-control" formControlName="nombreRecibe" maxlength="29" id="city" placeholder="Nombre Completo" required="">
                            </div>
                            <div class="col-md-4 d-flex justify-content-center align-items-center gap-3">
                                <button class="btn btn-solid" (click)="submit()" id="guardarBoton" >
                                    <span>Guardar</span>
                                </button>&nbsp;
                                <button class="btn btn-solid" (click)="closeModal(false)" id="guardarBoton" >
                                    <span>Cancelar</span>
                                </button>&nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>